import { useEffect, useRef, useState } from 'react'
import { onPlaceChanged, updateGTM } from '../../map_utils/index'
import { SearchType } from '../../interfaces/index'
import { useComponentSize } from '../../../../residential/hooks'
import { Icon } from 'utils'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../state'


const Search = ({ autocomplete, map, searchRef }: SearchType) => {
  const { state, actions } = useStateMachine({ updateStore })
  const [show, setShow] = useState(false)
  const [mobile, setMobile] = useState(false)
  const ref = useRef('')
  const searchNodeMobile = useRef<HTMLDivElement>(null)
  const filterNode = useRef<HTMLDivElement>(null)
  const searchButtonNode = useRef<HTMLButtonElement>(null)
  const filterButtonNode = useRef<HTMLButtonElement>(null)

  const onChange = () => {
    actions.updateStore({ address: searchRef?.current?.value })
    if (map) {
      onPlaceChanged({ autocomplete, map })
      if (
        searchRef?.current?.value != null &&
        ref?.current != null &&
        ref?.current !== searchRef?.current?.value
      ) {
        ref.current = searchRef?.current?.value
        // Retrieve place for analytics
        const place = autocomplete.getPlace()
        if (place) {
          // Calculate the name to pass analytics
          let name = place.name
          if (place.place_id) {
            name = place.vicinity
          }
          name = name.replace(/[0-9]/g, '')
          updateGTM('search', name)
        }
      }
    }
  }

  const onClick = () => {
    setShow(!show)
  }
  const widthRef = useRef<HTMLDivElement>(null)
  const size = useComponentSize(widthRef)

  // hide open filter or search dropdown on click outside
  const handleMousedown = (e: MouseEvent) => {
    const { target } = e
    if (
      !filterNode?.current?.contains(target as Node) &&
      !filterButtonNode?.current?.contains(target as Node)
    ) {
      // outside click
      setShow(false)
    }
    if (
      !searchNodeMobile?.current?.contains(target as Node) &&
      !searchButtonNode?.current?.contains(target as Node)
    ) {
      // outside click
      searchNodeMobile?.current?.classList.add('wc-outages__searchdrop--hidden')
    }
  }

  const toggleSearch = () => {
    searchNodeMobile?.current?.classList.toggle(
      'wc-outages__searchdrop--hidden'
    )
  }

  useEffect(() => {
    if (size && size.width) {
      setMobile(size.width < 720)
    }
  }, [size])

  useEffect(() => {
    document.addEventListener('mousedown', handleMousedown)
    return () => {
      document.removeEventListener('mousedown', handleMousedown)
    }
  }, [])

  useEffect(() => {
    if (!state?.address && searchRef?.current?.value) {
      searchRef.current.value = ''
    }
  }, [state?.address, searchRef])

  if (autocomplete) {
    autocomplete.addListener('place_changed', onChange)
  }

  return (
    <div ref={widthRef}>
      <div className="wc-outages__search bg-ocean">
        <div className="flex-shrink">
          <label
            htmlFor="outage-map-ascx-address"
            className="wc-outages__sr-only"
          >
            Enter an address
          </label>

          <button
            className="wc-outages__search__button"
            onClick={toggleSearch}
            ref={searchButtonNode}
          >
            <Icon
              role="presentation"
              width="32.5"
              height="32.501"
              fill="#fff"
              id="#magnifier"
            />
            Search
          </button>
        </div>
        {!mobile && (
          <input
            ref={searchRef}
            type="text"
            id="outage-map-ascx-address"
            name="address"
            className="wc-outages__input"
            placeholder="Enter an address"
            autoComplete="off"
          />
        )}
        <div className="flex-shrink">
          {mobile && (
            <a
              href={state?.outagesFormUrl}
              className="wc-outages__outage__button"
            >
              Sign up for water supply alerts
            </a>
          )}
          {!mobile && (
            <a
              href={state?.outagesFormUrl}
              className="wc-outages__warning__button"
            >
              Sign up for water supply alerts
            </a>
          )}
        </div>

        {!mobile && (
          <button
            className="wc-outages__filter__button"
            onClick={onClick}
            ref={filterButtonNode}
            aria-expanded={show}
          >
            <Icon
              role="presentation"
              width="32.182"
              height="30.654"
              fill="#fff"
              id="#filter"
            />
            Filter
          </button>
        )}

        {!mobile && (
          <div ref={filterNode}>
            {show && (
              <div className="wc-outages__filter__pop" role="form">
                <h6>Filter outages by:</h6>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      onChange={() => {
                        actions.updateStore({ active: !state?.active })
                      }}
                      checked={state?.active}
                    />
                    <span className="wc-outages__filter__box wc-outages__filter__box--red" />
                    Current Water Outage
                  </label>
                </div>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      onChange={() => {
                        actions.updateStore({ completed: !state?.completed })
                      }}
                      checked={state?.completed}
                    />
                    <span className="wc-outages__filter__box wc-outages__filter__box--green" />
                    Recently Completed Works
                  </label>
                </div>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      onChange={() => {
                        actions.updateStore({ registered: !state?.registered })
                      }}
                      checked={state?.registered}
                    />
                    <span className="wc-outages__filter__box wc-outages__filter__box--yellow" />
                    Upcoming Water Outage
                  </label>
                </div>
                <div>
                  <label>
                    <input
                      type="checkbox"
                      onChange={() => {
                        actions.updateStore({ major: !state?.major })
                      }}
                      checked={state?.major}
                    />
                    <span className="wc-outages__filter__box wc-outages__filter__box--orange" />
                    Major Works
                  </label>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div
        ref={searchNodeMobile}
        className="wc-outages__searchdrop wc-outages__searchdrop--hidden"
      >
        {mobile && (
          <input
            ref={searchRef}
            type="text"
            id="outage-map-ascx-address"
            name="address"
            className="wc-outages__input wc-outages__input--mobile"
            placeholder="Enter an address"
            autoComplete="off"
          />
        )}
      </div>
    </div>
  )
}

export default Search

